import "//shopakaso.com/cdn/shop/t/24/assets/jquery.js?v=147293088974801289311779698570"
import "//shopakaso.com/cdn/shop/t/24/assets/swiper@11.min.js?v=104684603862494721831779698625"

// 入口函数，在页面加载完成后执行
function main() {
  Alpine.data("brave7lemb", function () {
    const el = $(this)
    return {
      init() {
        $(function () {
          // $(window).scroll(function (event) {
          //   const one = el.find(".poster-six").offset().top;
          //   const scroll = $(window).scrollTop();
          //   if (scroll > one) {
          //     el.find(".video-old1").trigger("play");
          //   }
          // });
          let slide = true
          $('.brave7le-list-down').click(function () {
            if (slide) {
              $('.choose-link-lists').slideDown(300)
              slide = false
              $(this).addClass('list-down-spec')
            } else {
              console.log("no LIST!")
              $('.choose-link-lists').slideUp(300)
              slide = true
              $(this).removeClass('list-down-spec')
            }
          });
          $(window).scroll(function (event) {
            if ($(window).scrollTop() > 0) {
              el.find(".product-details-top").addClass("product-details-special");
              $(".nav-container").hide();
              $(".nav").hide();
              el.find(".choose-link-lists").slideUp(300);
              slide = true;
              el.find(".list-down").removeClass("list-down-spec");
              $(".mobile-header").hide();
            } else {
              el.find(".product-details-top").removeClass("product-details-special");
              $(".mobile-header").show();
              $(".nav").show();
              $(".nav-container").show();
              $(".header-wrapper").show();
            }
          });
          el.find(".product-details-one").click(function () {
            el.find(".choose-link-lists").slideUp(300);
            slide = true;
            el.find(".list-down").removeClass("list-down-spec");
          });
        });
      },
    };
  });
}

document.addEventListener('alpine:init', main)
